<script setup>
import { ref } from "vue";
import { DialogDescription, DialogTitle } from "@headlessui/vue";
import Modal from "./Modal.vue";
import { ExclamationTriangleIcon } from "@heroicons/vue/24/outline";
import { useI18n } from "vue-i18n";

defineProps({
    title: String,
    description: String,
    label: String,
});

defineEmits(["confirm"]);

const { t: __ } = useI18n();

const modal = ref();

const show = () => {
    modal.value?.show();
};

const hide = () => {
    modal.value?.hide();
};

defineExpose({ show, hide });
</script>

<template>
    <Modal ref="modal">
        <div class="px-4 pt-5 pb-4 sm:p-6">
            <div class="sm:flex sm:items-start">
                <div class="flex-shrink-0 mx-auto w-12 h-12 flex justify-center items-center bg-yellow-500 rounded-full sm:w-10 sm:h-10 sm:mx-0">
                    <ExclamationTriangleIcon class="w-6 h-6 text-gray-200" aria-hidden="true" />
                </div>
                <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900 dark:text-white">
                        {{ title }}
                    </DialogTitle>
                    <div class="mt-2">
                        <DialogDescription class="text-sm text-gray-600 dark:text-gray-400">
                            {{ description }}
                        </DialogDescription>
                    </div>
                </div>
            </div>
            <div class="mt-5 sm:flex sm:flex-row-reverse sm:mt-4">
                <button
                    type="button"
                    class="w-full inline-flex justify-center items-center px-3 py-2 text-sm font-semibold text-white bg-yellow-500 rounded-md shadow-sm dark:hover:bg-yellow-400 focus-visible:outline-2 focus-visible:outline-yellow-500 focus-visible:outline focus-visible:outline-offset-2 hover:bg-yellow-600 sm:w-auto sm:ml-3"
                    @click="$emit('confirm')">
                    {{ label }}
                </button>
                <button
                    type="button"
                    class="w-full inline-flex justify-center items-center px-3 py-2 mt-3 text-sm font-semibold text-gray-600 bg-gray-50 rounded-md dark:text-gray-400 dark:bg-gray-800 dark:focus-visible:outline-gray-700 dark:hover:text-gray-200 dark:hover:bg-gray-700 focus-visible:outline-2 focus-visible:outline-gray-100 focus-visible:outline focus-visible:outline-offset-2 hover:text-gray-800 hover:bg-gray-100 hover:shadow-sm sm:w-auto sm:mt-0"
                    @click="hide">
                    {{ __("Annuler") }}
                </button>
            </div>
        </div>
    </Modal>
</template>
